
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { ensureValueIsDate } from '@/services/DateHelpers'
import { IdName } from '@ViewModels/IdName'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { PartySubscriptionCreateDto } from '@ViewModels/PartySubscriptionCreateDto'
import { SubscriptionProductModel } from '@ViewModels/SubscriptionProductModel'
import { Alert } from '@/components'
import { SaveButton, StandardButton } from '@/components/buttons'
import { Checkbox, DatePicker, DropDownSelect } from '@/components/formGroups'

export default Vue.extend({
   name: 'CreateUserSubscription',
   props: {
      schoolId: String,
      editingItem: Object as () => PartyIdentityUserDto,
   },
   data() {
      return {
         subscriptionExpiry: new Date(),
         productId: '',
         products: [] as SubscriptionProductModel[],
         processing: false,
         processed: false,
      }
   },
   computed: {
      productOptions(): NameValuePair[] {
         return this.products.map(product => ({
            name: product.Name,
            value: product.Id,
         }))
      },
   },
   mounted() {
      this.loadSubscriptionProducts()
   },
   methods: {
      async loadSubscriptionProducts() {
         this.products = await Api.loadSubscriptionProducts()
      },
      async action() {
         this.processing = true
         try {
            const subscription = {
               ProductId: this.productId,
               SubscriptionExpiry: this.subscriptionExpiry,
               PartyId: this.editingItem.PartyId,
               SchoolId: this.schoolId,
            } as PartySubscriptionCreateDto
            await Api.createPartySubscription(subscription)
            this.processed = true
            this.processing = false
            this.$emit('saved')
            this.$emit('cancel')
         } catch {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
      StandardButton,
      DatePicker,
      Checkbox,
      DropDownSelect,
   },
})
